export default __webpack_public_path__ + "static/media/Nunito-ExtraLight.a4b58130.woff";